// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_it-0";
export var optionCard = "_it-1";